import { graphql } from "~/gql";

export const UPDATE_MATTER_TEMPLATE = graphql(/* GraphQL */ `
  mutation updateMatterTemplate($id: Float!, $data: MatterUpdateInput!) {
    updateMatterTemplate(id: $id, data: $data) {
      ...MatterTemplateParts
    }
  }
`);

export const UPDATE_MATTER_TEMPLATES = graphql(/* GraphQL */ `
  mutation UpdateManyMatterTemplate($input: [UpdateManyTemplatesInput!]!) {
    updateManyMatterTemplate(input: $input) {
      ...MatterTemplateParts
    }
  }
`);
